<template>
	<div id="company-information" class="tab-pane fade active show">
		<div class="row table-responsive">
			<table class="table table-sm" aria-describedby="company-information">
				<tbody>
					<tr>
						<td>Company Name</td>
						<td>{{ company.name | placeholder }}</td>
					</tr>
					<tr>
						<td>Date of Incorporation</td>
						<td>{{ company.date_of_incorporation | toDate('LL') | placeholder }}</td>
					</tr>
					<tr>
						<td>Certificate of Incorporation Number</td>
						<td>{{ company.registration_number | placeholder }}</td>
					</tr>
					<tr>
						<td>Business Category</td>
						<td>{{ company.business_category | placeholder }}</td>
					</tr>
					<tr>
						<td>Fax Number</td>
						<td>{{ company.fax | placeholder }}</td>
					</tr>
					<tr>
						<td>GRA Tax ID Number</td>
						<td>{{ company.tin | placeholder }}</td>
					</tr>
					<tr>
						<td>Industry</td>
						<td>{{ company.industry_details ? company.industry_details.name : '' | placeholder }}</td>
					</tr>
					<tr>
						<td>Category of business</td>
						<td>{{ company.business_category | placeholder }}</td>
					</tr>
					<tr v-if="company.parent_company_name">
						<td>Parent Company Name</td>
						<td>{{ company.parent_company_name | placeholder }}</td>
					</tr>
					<tr v-if="company.parent_company_registration_country">
						<td>Parent Company Country</td>
						<td>{{ company.parent_company_registration_country | placeholder }}</td>
					</tr>
					<tr>
						<td>Country</td>
						<td>{{ company.country_details.name }}</td>
					</tr>
					<tr>
						<td>City</td>
						<td>{{ city | placeholder }}</td>
					</tr>
					<tr>
						<td>Physical Address</td>
						<td>{{ company.address_line_1 | placeholder }}</td>
					</tr>
					<tr>
						<td>Ghana Post GPS</td>
						<td>{{ company.address_line_2 | placeholder }}</td>
					</tr>
					<tr>
						<td>Postal Address</td>
						<td>{{ company.address_line_3 | placeholder }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		city() {
			const { city_details, city } = this.company;

			return city_details ? city_details.name : city;
		},
		phoneNumbers() {
			const { phone, other_phone } = this.company;
			const phoneNumbers = [].concat([phone, other_phone]);

			return phoneNumbers.toString();
		},
	},
	props: ['company'],
};
</script>
